<template>
    <div class="popin-frame">
        <div ref="containerElRef" class="popin-container">
            <div class="popin-title-container">
                <cross-icon
                    class="theme-svg-button tiny-icon icon-button"
                    tabindex="0"
                    @click="emitClose"
                    @keypress.enter="emitClose"></cross-icon>
            </div>
            <slot name="popin-body"></slot>
        </div>
        <div ref="surroundElRef" class="popin-surround" @click="surroundClick"></div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import CrossIcon from "@/scalar/cross.svg";

const props = withDefaults(defineProps<{
    zIndex?: number;
    modal?: boolean;
}>(), {
    zIndex: 1000,
    modal: false
});

const emit = defineEmits<{
    close: [];
}>();

const surroundElRef = ref<HTMLDivElement | null>(null);
const containerElRef = ref<HTMLDivElement | null>(null);

function emitClose(): void {
    emit("close");
}

function surroundClick(): void {
    if (props.modal) { return; }
    emitClose();
}

onMounted(() => {
    if (surroundElRef.value !== null) { surroundElRef.value.style.zIndex = "" + props.zIndex; }
    if (containerElRef.value !== null) { containerElRef.value.style.zIndex = "" + (props.zIndex + 1); }
});
</script>

<style>
.popin-frame {
    height: 100%;
}

.popin-container {
    background-color: var(--bg-colour);
    width: 60vw;
    position: fixed;
    top: 20vh;
    left: 20vw;
    display: flex;
    flex-direction: column;
}

.popin-title-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.popin-button {
    font-weight: bolder;
    margin: 0.25em;
    cursor: pointer;
}

.popin-surround {
    background-color: var(--ink-colour);
    opacity: 0.25;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
}
</style>
